<template>
  <div>
    <md-card>
      <md-card-header class="md-layout md-alignment-top-space-between">
        <span class="md-title" v-if="view === 'Create'">Create a New Weekend</span>
        <span class="md-title" v-if="view === 'Copy'">Copy a Weekend</span>
        <span>
          <md-button @click="view = 'Create'" v-if="view !== 'Create'">Create</md-button>
          <md-button @click="view = 'Copy'" v-if="view !== 'Copy'">Copy</md-button>
            </span>
      </md-card-header>
      <md-card-content v-if="view === 'Create'">
        <label style="display: flex;">Courses</label>
        <md-checkbox v-model="newWeekend.courseIds" v-for="course in courses" :key="course.versionedId.id"
                     :value="course.versionedId.id">
          {{course.name}}
        </md-checkbox>

        <md-datepicker v-model="newWeekend.start" :md-disabled-dates="startDateFilter">
          <!--<label>Start date</label>-->
          <strong>Start Date</strong>
        </md-datepicker>

        <md-datepicker v-model="newWeekend.end" :md-disabled-dates="endDateFilter">
          <!--<label>End Date</label>-->
          <Strong>End Date</Strong>
        </md-datepicker>

        <md-field>
          <label>Days</label>
          <md-input :value.sync="createDays" type="number" disabled></md-input>
        </md-field>

        <md-field>
          <label>Name</label>
          <md-input v-model="newWeekend.name"/>
        </md-field>
        <md-field>
          <md-icon>access_time</md-icon>
          <label>Daily Start Time</label>
          <md-input v-model="newWeekend.dailyStartTime" type="time" step="60"/>
        </md-field>
        <md-field>
          <md-icon>access_time</md-icon>
          <label>Daily End Time</label>
          <md-input v-model="newWeekend.dailyEndTime" type="time" step="60"/>
        </md-field>

        <div>
          <strong style="font-size: 16px; vertical-align: middle; line-height:40px;">Sections</strong>
          <md-button class="md-icon-button md-raised md-primary" @click="addSection">
            <md-icon>add</md-icon>
          </md-button>
        </div>
        <table v-if="newWeekend.sections && newWeekend.sections.length > 0" width="100%" style="text-align: center">
          <tr style="font-size: 16px;">
            <th>Name</th>
            <th>Course</th>
            <th>Max Students</th>
            <th>Current Students</th>
          </tr>
          <tr :key="index" v-for="(section, index) in newWeekend.sections">
            <td>
              <md-field>
                <md-input v-model="section.name"></md-input>
              </md-field>
            </td>
            <td>
              <md-field>
                <md-select v-model="section.courseId" md-dense>
                  <md-option value="">None</md-option>
                  <md-option v-for="courseId in newWeekend.courseIds" :value="courseId" :key="courseId">{{getCourse(courseId).name}}</md-option>
                </md-select>
              </md-field>
            </td>
            <td>
              <md-field>
                <md-input v-model="section.maxStudents" type="number"></md-input>
              </md-field>
            </td>
            <td>
              <md-field>
                <md-input v-model="section.currentStudents" type="number"></md-input>
              </md-field>
            </td>
            <td>
              <md-button class="md-icon-button md-dense md-primary" @click="newWeekend.sections.splice(index,1)">
                <md-icon class="md-morph-final">delete</md-icon>
              </md-button>
            </td>
          </tr>
        </table>
        <p v-else class="empty-description">
          You don't have any sections yet. Would you like to create one?
        </p>
        <md-dialog-actions>
          <md-button class="md-primary md-raised" @click="createWeekend" v-bind:disabled="!dialogCreateActive">Create
          </md-button>
        </md-dialog-actions>

      </md-card-content>

      <md-card-content v-if="view === 'Copy'">
        <div v-if="weekends && weekends.length > 0">
          <md-field>
            <label>Weekend</label>
            <md-select v-model="weekendCopy.weekendId">
              <md-option v-for="weekend in weekends" :value="weekend.versionedId.id" :key="weekend.versionedId.id">
                {{weekend.name}}
              </md-option>
            </md-select>
          </md-field>

          <md-datepicker v-model="weekendCopy.start">
            <!--<label>Start date</label>-->
            <strong>Start Date</strong>
          </md-datepicker>

          <md-field>
            <label>Name</label>
            <md-input v-model="weekendCopy.name"></md-input>
          </md-field>

          <div style="text-align: left">Select staff to not preserve:
            <md-button class="md-icon-button" @click="showStaffToNorPreserve = !showStaffToNorPreserve">
              <md-icon v-if="showStaffToNorPreserve">expand_less</md-icon>
              <md-icon v-if="!showStaffToNorPreserve">expand_more</md-icon>
            </md-button>
          </div>
          <div v-if="showStaffToNorPreserve">
            <md-checkbox v-for="staff in staffList" v-model="weekendCopy.staffToNotPreserve"
                         :key="staff.name" :value="staff.versionedId.id">{{staff.name}}
            </md-checkbox>
          </div>
          <md-dialog-actions>
            <md-button class="md-primary md-raised" @click="copyWeekend" v-bind:disabled="!dialogCopyActive">Copy
            </md-button>
          </md-dialog-actions>
        </div>
        <div v-if="!weekends || weekends.length <= 0">
          There aren't any weekends to copy (yet).
        </div>
      </md-card-content>
    </md-card>

  </div>
</template>

<script>
  import moment from 'moment'

  var extractDate = function(date) {
    return moment(date).format("YYYY-MM-DD");
  };

  export default {
    name: "new-weekend",
    data() {
      return {
        newWeekend: {
          name: 'Weekend',
          courseIds: [],
          sections: [
            {
              name: 'Staff',
              courseId: null,
              currentStudents: '0',
              maxStudents: '0'
            }
          ],
          dailyStartTime: '08:00:00',
          dailyEndTime: '23:00:00'
        },
        weekendCopy: {
          weekendId: '',
          name: 'Weekend',
          staffToNotPreserve: []
        },
        showStaffToNorPreserve: false,
        saving: false,
        view: 'Create'
      }
    },
    computed: {
      weekends() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.weekends) {
          return this.$store.state.currentCityDetails.weekends;
        } else {
          return [];
        }
      },
      courses() {
        if (this.$store.state.currentCityDetails && this.$store.state.currentCityDetails.courses) {
          return this.$store.state.currentCityDetails.courses;
        } else {
          return [];
        }
      },
      createDays() {
        if (!this.newWeekend.start || !this.newWeekend.end) {
          return 0;
        }
        return Math.round((this.newWeekend.end - this.newWeekend.start) / 86400000) + 1;
      },
      dialogCreateActive() {
        var active = this.newWeekend.start && this.newWeekend.end &&
          this.newWeekend.sections !== null && !this.saving;

        this.newWeekend.sections.forEach(section => {
          active = active && section.name && section.name.length > 0 && section.maxStudents && section.currentStudents;
        });

        return active;
      },
      dialogCopyActive() {
        return this.weekendCopy.start &&
          this.weekendCopy.weekendId && this.weekendCopy.weekendId.length > 0 && !this.saving;
      },
      watchedCreateStartDate() {
        return this.newWeekend.start;
      },
      watchedCopyStartDate() {
        return this.weekendCopy.start;
      },
      staffList() {
        if (this.$store.state.currentCityDetails) {
          this.$store.state.currentCityDetails.staff.forEach((staff) => {
            if (!staff.enabled && this.weekendCopy.staffToNotPreserve.indexOf(staff.versionedId.id) === -1)
              this.weekendCopy.staffToNotPreserve.push(staff.versionedId.id);
          });

          return this.$store.state.currentCityDetails.staff;
        } else {
          return [];
        }
      }
    },
    watch: {
      watchedCreateStartDate() {
        this.createName();
      },
      watchedCopyStartDate() {
        this.copyName();
      }
    },
    methods: {
      createName() {
        if (this.newWeekend.start && this.newWeekend.name === "Weekend") {
          this.newWeekend.name = "Weekend - " + moment(this.newWeekend.start).format("MMMM Do YYYY");
        }
      },
      copyName() {
        if (this.weekendCopy.start && this.weekendCopy.name === "Weekend") {
          this.weekendCopy.name = "Weekend - " + moment(this.weekendCopy.start).format("MMMM Do YYYY");
        }
      },
      addSection() {
        var lastSectionNumber = 0;
        this.newWeekend.sections.forEach(section => {
          if (section.name) {
            var numbers = section.name.match(/[0-9]+/g);
            if (numbers && numbers.length > 0)
              lastSectionNumber = Number(numbers[0]);
          }
        });

        var courseId = null;
        if (this.newWeekend.courseIds && this.newWeekend.courseIds.length === 1)
          courseId = this.newWeekend.courseIds[0];

        var newSectionNUmber = lastSectionNumber + 1;
        this.newWeekend.sections.push({
          name: 'S' + newSectionNUmber,
          courseId: courseId,
          currentStudents: '0'
        });
      },
      getCourse(courseId) {
        var selectedCourse = {};
        this.courses.forEach(course => {
          if (course.versionedId.id === courseId)
            selectedCourse = course;
        });
        return selectedCourse;
      },
      startDateFilter(day) {
        if (!this.newWeekend.end) {
          return false;
        }
        return day > this.newWeekend.end;
      },
      endDateFilter(day) {
        if (!this.newWeekend.start) {
          return false;
        }
        return day < this.newWeekend.start;
      },
      createWeekend() {
        this.saving = true;
        this.$store.api.rpcRequest('createWeekend', {
          cityId: this.$store.state.currentCity.versionedId.id,
          courseIds: this.newWeekend.courseIds,
          start: extractDate(this.newWeekend.start),
          end: extractDate(this.newWeekend.end),
          name: this.newWeekend.name,
          dailyStart: this.newWeekend.dailyStartTime,
          dailyEnd: this.newWeekend.dailyEndTime,
          sections: this.newWeekend.sections
        }, newWeekend => {
          this.$router.push('weekend/' + newWeekend.versionedId.id);
        }, errorMessage => {
          this.saving = false;
        });
      },
      copyWeekend() {
        this.saving = true;
        this.$store.api.rpcRequest('copyWeekend', {
          cityId: this.$store.state.currentCity.versionedId.id,
          start: extractDate(this.weekendCopy.start),
          name: this.weekendCopy.name,
          staffToNotPreserve: this.weekendCopy.staffToNotPreserve,
          weekendId: this.weekendCopy.weekendId
        }, newWeekend => {
          this.$router.push('weekend/' + newWeekend.versionedId.id);
        }, errorMessage => {
          this.saving = false;
        });
      }
    }
  }
</script>

<style scoped>
  .md-checkbox {
    display: flex;
  }

  .empty-description {
    margin: 1em 0;
    font-size: 16px;
    line-height: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/city/weekend/NewWeekend.vue